Sage.home = {
  init: function() {
    // JavaScript to be fired on the home page
  },
  finalize: function() {
    // JavaScript to be fired on the home page, after the init JS
  }
};
